import { nationalDigits } from '../lib/phone';

// Fixed +91 prefix; the user types only the 10-digit number. Pasted numbers that
// include +91 / 91 / 0 are reduced to their last 10 digits. onChange receives
// '+91XXXXXXXXXX' (or '' when empty).
export const PhoneInput = ({
  value, onChange, className = '', inputClassName = '', prefixClassName = '',
  placeholder = '98765 43210', testId, id, name, required, disabled, autoFocus,
  autoComplete = 'tel-national', onBlur,
}) => {
  const digits = nationalDigits(value);
  const handle = (e) => {
    let d = e.target.value.replace(/\D/g, '');
    if (d.length > 10) d = e.nativeEvent?.inputType === 'insertFromPaste' ? d.slice(-10) : d.slice(0, 10);
    onChange(d ? `+91${d}` : '');
  };
  return (
    <div className={`flex items-center ${disabled ? 'opacity-60' : ''} ${className}`} data-testid={testId ? `${testId}-wrap` : undefined}>
      <span className={`shrink-0 select-none font-mono text-[0.95em] opacity-60 pr-2 mr-2 border-r border-zinc-500/40 ${prefixClassName}`} aria-hidden="true">+91</span>
      <input
        id={id} name={name} type="tel" inputMode="numeric" autoComplete={autoComplete}
        value={digits} onChange={handle} onBlur={onBlur} placeholder={placeholder}
        required={required} disabled={disabled} autoFocus={autoFocus}
        className={`flex-1 min-w-0 bg-transparent border-0 outline-none p-0 font-mono tracking-wide placeholder:text-zinc-500 ${inputClassName}`}
        data-testid={testId}
      />
    </div>
  );
};
